import { __decorate, __metadata } from "tslib";
import { Injectable } from 'angular-ts-decorators';
var ContactUsApiService = (function () {
    function ContactUsApiService($http) {
        this.$http = $http;
    }
    ContactUsApiService.prototype.get = function (id) {
        return this.$http
            .get("/support/api/contact-us/" + id, { cache: true })
            .then(function (response) { return response.data; });
    };
    ContactUsApiService.$inject = ['$http'];
    ContactUsApiService = __decorate([
        Injectable('contactUsApi'),
        __metadata("design:paramtypes", [Function])
    ], ContactUsApiService);
    return ContactUsApiService;
}());
export { ContactUsApiService };
